<!--每日分析报表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          v-decorator="['organizationCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="defaultSelect"
          slot="organizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationCode"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.ESTATE_DAILY_PLAN_ANALYSIS_REPORT_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="realCompletedQty" slot-scope="{ record }">
            <a @click="toDetails(record)" href="javascript:;">{{ record.realCompletedQty }}</a>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetInvDailyPlanAnalysisList } from '@/api/report/estate-daily-plan-analysis-report.js'
import { generateLsTableResData } from '@/utils/util.js';
import moment from 'moment'
import cacheSearch from '@/mixins/cacheSearch'

export default {
  // eslint-disable-next-line
  name: 'Estate-daily-plan-analysis-report', // name要和rms配置菜单路由保存一致(首字母大写)
  mixins: [cacheSearch],
  components: { },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetInvDailyPlanAnalysisList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        scheduledCompletionDate: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '工厂',
          decorator: ['organizationCode'],
          type: 'organizationCode'
        },
        {
          label: '计划完成时间',
          decorator: ['scheduledCompletionDate'],
          type: 'range',
          disposeFormat: {
            staScheduledCompletionDate: (change) => {
              return change[0].format('YYYY-MM-DD')
            },
            endScheduledCompletionDate: (change) => {
              return change[1].format('YYYY-MM-DD')
            }
          }
        }
      ],
      // 表格字段
      columns: [
        {
          title: '工厂',
          dataIndex: 'organizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '所属车间code',
          dataIndex: 'workCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '所属车间',
          dataIndex: 'workshopDesc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划完成时间',
          dataIndex: 'scheduledCompletionDate',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划完成',
          dataIndex: 'planCompletedQty',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '实际完成',
          dataIndex: 'realCompletedQty',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'realCompletedQty' }
        },
        {
          title: '实际产值（万）',
          dataIndex: 'realOutputValue',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'realOutputValue' }
        },
        {
          title: '缺口',
          dataIndex: 'gapQty',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: 'POWER值',
          dataIndex: 'powerbl',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '已入库汇总',
          dataIndex: 'receiptSummary',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '已送货汇总',
          dataIndex: 'deliverySummary',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created () {
    // 处理缓存逻辑
    this.getHistoryCache('refSearchForm', 'organizationCode', { scheduledCompletionDate: ['staScheduledCompletionDate', 'endScheduledCompletionDate'] })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    toDetails(item) {
      this.$router.push({ path: `/estate-daily-plan-analysis-report/analysisReportDetail/${item.id}` })
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        scheduledCompletionDate: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport () {
      // const params = this.$refs.dataTable.searchParams
      // this.$refs.download.openModal(params)
      this.download('/inv/invDailyPlanAnalysis/export', this.$refs.dataTable.searchParams, `产业园每日计划分析报表_${moment().format('YYYY-MM-DD')}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less"></style>
